// <define:__environment__>
var define_environment_default = { oneInchDevPortalHost: "https://1inch.trade", oneInchDevPortalToken: "jdNC1wwl3UWnVktZWOSo21EMMHCnHeGv", walletConnectProjectId: "37448c3292821561f4fdeef67e07fbc3", infuraApiKey: "0d30a77f433543db8a0ca3706904d8f8", approvalHolder: "0xA12ac8D881142C249066E7293647A197D851FE8c" };

// libs/core/src/lib/environment/get-environment-value.ts
var requiredEnvFields = [
  "oneInchDevPortalHost",
  "walletConnectProjectId"
];
var env = {
  oneInchDevPortalHost: "https://api.1inch.dev"
};
var embeddedMode = false;
function getEnvironmentValue(valueName) {
  if (embeddedMode && env[valueName] === void 0 && requiredEnvFields.includes(valueName)) {
    throw new Error(`environment value ${valueName} not exist`);
  }
  if (embeddedMode) {
    return env[valueName];
  }
  return define_environment_default[valueName] ?? env[valueName];
}
function setEnvironmentValue(valueName, value) {
  env[valueName] = value;
}
function enabledEmbeddedMode() {
  embeddedMode = true;
}
export {
  enabledEmbeddedMode,
  getEnvironmentValue,
  setEnvironmentValue
};
//# sourceMappingURL=index.esm.js.map
